module.exports = __webpack_public_path__ + "static/media/iWatt.c1208b97.webp";